import '../../modules/mode-components';

import * as angular from 'angular';
import { highlightElement } from 'prismjs';

import { HIGHLIGHT_LIMIT } from '../../common/constants';

const CodeHighlightDirective = function ($timeout) {
  return {
    transclude: true,
    scope: {
      lang: '@?',
      lineNumbers: '@?',
      start: '@?',
    },
    template: '<pre><code class="mode-prism" ng-show="prismLoaded" ng-transclude></code></pre>',
    link: function (scope: angular.IScope, elem, attrs) {
      const code = elem.find('.mode-prism');
      elem.addClass('mode-code');
      if (attrs.lang) {
        code.addClass('language-' + attrs.lang);
      }
      if (attrs.lineNumbers) {
        elem.find('pre').addClass('line-numbers');
      }

      if (attrs.start) {
        elem.find('pre').attr('data-start', '' + attrs.start);
      }

      $timeout(() => {
        if (code[0].innerHTML.length < HIGHLIGHT_LIMIT) {
          highlightElement(code[0], false);
        }

        scope.prismLoaded = true;
      });
    },
  };
};

CodeHighlightDirective.$inject = ['$timeout'];

angular.module('mode.components').directive('modeCode', CodeHighlightDirective);
